module.exports = __webpack_public_path__ + "img/ledgers.closed.weekly.9b5dbfe7.png";